import withUser from '~lib/common/hoc/withUser';

import NoOrgGuard from './NoOrgGuard';

export default withUser()(NoOrgGuard);
